import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Times } from '../../../components/Icon';
import { Modal } from '../../../components/Modal';
import { Button } from '../../../components/Buttons';
import { removeVehicleOption } from '../actions';
import { VehicleOption } from '../components/Option';

const STATE = {
  deleteOptionConfirm: {
    optionId: null,
    vehicleId: null,
  },
};

const Container = styled.div``;

export const Option = styled.div`
  > .box {
    border-bottom: 1px solid #ddd;
  }
  .name {
    margin-right: 12px;
    width: 200px;
    min-width: 200px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class OptionsEditorComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  remove() {
    const { optionId, vehicleId } = this.state.deleteOptionConfirm;
    this.props.remove(optionId, vehicleId, this.reset.bind(this));
  }

  render() {
    const vehicle = this.props.vehicle;
    if (!vehicle || !vehicle.options) return null;
    return (
      <Container>
        <h3>{this.lbl('vehicle.details.options.title')}:</h3>
        <VBox>
          {vehicle.options.map(o => {
            if (this.state.deleteOptionConfirm.optionId === o.id) return this.renderDeleteConfirm(o);
            return (
              <HBox key={o.id}>
                <VehicleOption key={o.id} option={o} />
                <div className="name">
                  <Button
                    small
                    onClick={this.setStateFn({
                      deleteOptionConfirm: {
                        optionId: o.id,
                        vehicleId: vehicle.id,
                      },
                    })}
                  >
                    <Times />
                  </Button>
                </div>
              </HBox>
            );
          })}
        </VBox>
      </Container>
    );
  }

  renderDeleteConfirm(option) {
    return (
      <Modal
        key={option.id}
        onClose={this.reset.bind(this)}
        title={this.lbl('vehicle.details.option.modal.deleteConfirmationTitle')}
      >
        <div>
          {this.lbl('vehicle.details.option.modal.deleteConfirmationTitle')}
          <br />
          <Button onClick={this.remove.bind(this)}>{this.lbl('vehicle.details.option.modal.deleteBtn')}</Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('vehicle.details.option.modal.cancelBtn')}</Button>
        </div>
      </Modal>
    );
  }
}

OptionsEditorComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    remove(optionId, vehicleId, callback) {
      dispatch(removeVehicleOption(optionId, vehicleId, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const OptionsEditor = compose(
  withConnect,
  withRouter,
)(OptionsEditorComp);
